type RefinementChipsProps = {
  refinements: string[];
  onSelect: (refinement: string) => void;
};

export function RefinementChips({ refinements, onSelect }: RefinementChipsProps) {
  if (refinements.length === 0) {
    return null;
  }

  return (
    <div className="refinement-chips" aria-label="Suggested refinements">
      {refinements.map((refinement) => (
        <button
          className="refinement-chip"
          key={refinement}
          type="button"
          onClick={() => onSelect(refinement)}
        >
          {refinement}
        </button>
      ))}
    </div>
  );
}
